import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../Icon';
import { useContact } from '../SiteContent';
import T from './EditableText';

/** Abschlussband: Überschrift und Satz links, Anfrage und Telefon rechts. */
const CtaBand: React.FC<{
  titleKey: string;
  textKey: string;
  ctaKey?: string;
  to?: string;
  tone?: 'dark' | 'tinted';
}> = ({ titleKey, textKey, ctaKey, to = '/kontakt', tone = 'dark' }) => {
  const contact = useContact();
  return (
    <section className="shell section--tight">
      <div className={`hx-cta hx-cta--${tone}`}>
        <div>
          <h2 className="h-block">
            <T k={titleKey} />
          </h2>
          <p>
            <T k={textKey} />
          </p>
        </div>
        <div className="hx-cta__actions">
          {ctaKey && (
            <Link to={to} className="btn btn--primary">
              <T k={ctaKey} />
            </Link>
          )}
          <a href={contact.phoneHref} className={`btn ${tone === 'dark' ? 'btn--on-dark' : 'btn--ghost'}`} data-stelle="band">
            <Icon name="phone" size={18} />
            {contact.phoneLabel}
          </a>
        </div>
      </div>
    </section>
  );
};

export default CtaBand;
